import { EndorsementKey, type EndorsementConfig } from '../../types';
import {
  selectCheckedEndorsements,
  selectContractorToolsLimit,
  selectGrossAnnualSales,
} from '../../../../selectors/application';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.ContractorsInstallationAndTools,
  label: 'Contractor Tools Coverage',
  description: 'Select additional coverage for tools and installation. Your current coverage is $5,000.',
  recommended: false,
};

export const DEFAULT_LIMITS_OPTIONS = [
  { value: 10000, label: '$10,000' },
  { value: 15000, label: '$15,000' },
  { value: 20000, label: '$20,000' },
  { value: 25000, label: '$25,000' },
];

export const isContractorToolsValid = (state: ReduxState) => {
  const isChecked = selectCheckedEndorsements(state).includes(EndorsementKey.ContractorsInstallationAndTools);
  if (!isChecked) return true;
  const selectedContractorsToolsLimit = selectContractorToolsLimit(state);
  const grossAnnualSales = selectGrossAnnualSales(state) || Infinity;
  return Number(grossAnnualSales) >= Number(selectedContractorsToolsLimit);
};
